// extracted by mini-css-extract-plugin
module.exports = {"pintxo-tab":"Tab_pintxo-tab__ofjYc","pintxo-tab__content":"Tab_pintxo-tab__content__Iy_XU","pintxo-tab__indicator":"Tab_pintxo-tab__indicator__2Fqtz"};